import { render, staticRenderFns } from "./PlameSection.vue?vue&type=template&id=62b80b3d"
import script from "./PlameSection.vue?vue&type=script&lang=ts"
export * from "./PlameSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports